import { ApiResponse } from "@/types/api";

export const handleFirestoreError = <T>(
  error: any,
  operation: string
): ApiResponse<T> => {
  console.error(`Error ${operation}:`, error);
  return { success: false, error: error.message };
};
